// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zn_L","option":"styles_option__2emYR","active":"styles_active__1NZrZ"};